export default class LeadActionModel {
  type!: string
}
